import { render, staticRenderFns } from "./ClientsListTable.vue?vue&type=template&id=5795c1da&scoped=true&"
import script from "./ClientsListTable.vue?vue&type=script&lang=js&"
export * from "./ClientsListTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsListTable.vue?vue&type=style&index=0&id=5795c1da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795c1da",
  null
  
)

export default component.exports